import React, {useRef} from "react";
import {
    isMyDesignDetailInputs,
    isMyDesignDetailText,
    isMyDesignDetailTextArea
} from "../../const/MyDesignDetailTypeConst.ts";
import {FormControl, FormGroup, FormLabel} from "react-bootstrap";

interface MyDesignDetailInputProps {
    dto?: DesignTemplateDetailDto;
    add_class_name?: string;
    handleChange?: (value: string) => void;
    handleBlur?: () => void;
}

const MyDesignDetailInput:React.FC<MyDesignDetailInputProps> = ({
    dto = undefined,
    add_class_name = "",
    handleChange,
    handleBlur,
}) => {
    const onBlurHandler = React.useCallback((e:any) => {
        e.stopPropagation();
        if(handleBlur) {
            handleBlur();
        }
    }, [handleBlur])
    return <FormGroup className={add_class_name}>
        <FormLabel className="my-design-input-title">{dto?.title}</FormLabel>
        {dto && isMyDesignDetailText(dto?.type) &&
            <FormControl type="text"
                         name={dto?.field_name}
                         value={dto?.content || ""}
                         placeholder={dto?.placeholder}
                         minLength={dto?.min_value}
                         maxLength={dto?.max_value}
                         onChange={(e) => handleChange?.(e.target.value)}
                         onBlur={onBlurHandler}
            />
        }
        {dto && isMyDesignDetailTextArea(dto?.type) &&
            <FormControl as="textarea"
                         rows={5}
                         name={dto?.field_name}
                         value={dto?.content || ""}
                         placeholder={dto?.placeholder}
                         minLength={dto?.min_value}
                         maxLength={dto?.max_value}
                         onChange={(e) => handleChange?.(e.target.value)}
                         onBlur={onBlurHandler}
            />
        }

    </FormGroup>;
};
export default MyDesignDetailInput;